import axios from "axios";
import Qs from "qs";
import config from "@/config";
import router from "@/router";
import {
  Message
} from "iview";

const {
  baseURL,
  timeout,
  baseType
} = config;
let hostURL =baseURL;
const instance = axios.create({
  // 是否跨站点访问控制请求使用凭证(Cookie)
  withCredentials: false, // 允许携带cookie
  baseURL: hostURL, // 配置接口地址
  transformRequest: [
    data => Qs.stringify(data) // 序列化请求的数据
  ],
  timeout: timeout, // 配置请求超时
  // 修改请求头信息
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
});

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    const {
      data
    } = response;
    const success = data.success;
    const msg = data.msg;
    if (success) {
      if (data.data != '' && data.data != null) {
      } else {
        data.data = JSON.stringify(data.data);
      }
      return data; // 响应正确的数据
    } else {

      Message.error(msg); // 提示错误信息
    }
  }, error => {
    // 响应错误数据(错误情况分无token信息,错误码)
    var newError = error
    console.log("error",error)
    const {
      response,
      message,
      // config
    } = error;
    if (response) {
      console.log("error====",error.response.status)
      switch (error.response.status) {
        case 400:
          break;
        case 401:
          break;
        case 404:
          console.log("404");
          break;
        case 408:
          break;
        case 500:
          break;
        case 501:
          break;
        case 502:
          break;
        case 503:
          break;
        case 504:
          break;
        case 505:
          break;
        default:
          break;
      }
    } else {
      if(newError =='Error: Network Error'){
        newError='网络连接异常'
      }else{
        newError='访问数据超时'
      }
      Message.error({
        content: message
      });
    }
  }
);
export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js